// Copyright (c) 2016 Deere & Company

import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import Recommendation, {getDefaultState as getRecommendationState} from './recommendation';
import TimestampUser, {getDefaultState as getTimestampUserDefaultState} from './timestamp-user';
import TransferProduct, {getDefaultState as getTransferProductDefaultState} from './transfer-product';
import t from 'tcomb';

const TransferEnterAor = t.struct({
    approverComment: t.maybe(t.String),
    currentDealer: Dealer,
    id: t.String,
    isEnterAOR: t.maybe(t.Boolean),
    isRecommendation:t.maybe(t.Boolean),
    newDealer: Dealer,
    product: TransferProduct,
    reasonForChange: t.String,
    recommendation: t.maybe(Recommendation),
	rejectReason: t.maybe(t.String),
    requestDate: t.Number,
    requestedBy: TimestampUser,
    status: t.String
}, {
    name: 'TransferEnterAor',
    strict: true
});

export const getDefaultState = () => new TransferEnterAor({
    currentDealer: getDealerDefaultState(),
    id: '',
    isEnterAOR: false,
    isRecommendation: false,
    newDealer: getDealerDefaultState(),
    product: getTransferProductDefaultState(),
    reasonForChange: '',
    recommendation: getRecommendationState(),
	rejectReason: '',
    requestDate: 0,
    requestedBy: getTimestampUserDefaultState(),
    status: ''
});

export default TransferEnterAor;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/transfer-enter-aor.js